import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the tableBalanceAdjustmentsView.
 * Extends the JetView class to create a specific view for balance adjustments.
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'rating',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close edit'></span>"; // Icon for editing
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: _('ID'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Iso',
                                    header: _('Iso'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'NameCountry',
                                    header: _('Nombre'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Currency',
                                    header: _('Moneda'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'), // Localized header
                                    width: 100,
                                    options: [
                                        { id: 'A', value: _('Activo') }, // Active state
                                        { id: 'I', value: _('Inactivo') }, // Inactive state
                                    ],
                                },
                                {
                                    id: 'Language',
                                    header: _('Lenguage'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Utc',
                                    header: _('UTC'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'CellPrefix',
                                    header: _('Prefijo celular'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'CodePath',
                                    header: _('Código PATH'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                            ],
                            on: {
                                /**
                                 * Event triggered before loading data.
                                 * Displays a loading overlay.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Event triggered after loading data.
                                 * Hides the loading overlay.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay();
                                },
                            },
                            /**
                             * Event triggered when the datatable is ready.
                             * Displays a 'no data' overlay if there are no records.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            onClick: {
                                /**
                                 * Event triggered when the edit icon is clicked.
                                 * Opens the edit form for the selected item.
                                 * @param {Event} euv - The event object.
                                 * @param {String} id - The ID of the clicked item.
                                 */
                                edit: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('openEdit', [item]); // Trigger the openEdit event
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable instance
        var url = devConfig.geturlApi() + 'Setting/GetCountriesAll'; // API URL for fetching countries
        var filter = ''; // Filter string for API requests

        /**
         * Event listener for the 'report:filter' event.
         * Updates the grid data based on the provided filter data.
         * @param {Object} filterData - The filter data object.
         */
        this.on(this.app, 'report:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'DateM') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            if (object[i][0] != 'Date') {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                            } else {
                                if (object[i][0] == 'Date') {
                                    var date = object[i][1].replace(' 00:00:00', ''); // Remove time from date
                                    string1 = string1 + '&dateFrom=' + date;
                                    string1 = string1 + '&dateTo=' + date;
                                }
                                if (object[i][0] == 'DateM2') {
                                    var date = object[i][1].replace(' 00:00:00', ''); // Remove time from date
                                    string1 = string1 + '&dateFrom2=' + date;
                                    string1 = string1 + '&dateTo2=' + date;
                                }
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object from start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object from end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            filter = string1; // Update filter string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            $$('filterPopup').hide(); // Hide filter popup
        });

        /**
         * Event listener for the 'openEdit' event.
         * Opens the edit form for the selected item.
         * @param {Object} item - The item to edit.
         */
        this.on(this.app, 'openEdit', (item) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for the request
                })
                .post(devConfig.geturlApi() + 'Setting/GetCurrencies', '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Show error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text); // Parse response data
                        if (!data.HasError) {
                            data.data.forEach((currency) => {
                                currency.id = currency.Currency; // Set ID for currency
                                currency.value = currency.Currency + ' - ' + currency.Description; // Set display value for currency
                            });
                            data.Data.forEach((language) => {
                                language.id = language.Language; // Set ID for language
                                language.value = language.Language + ' - ' + language.Description; // Set display value for language
                            });
                            webix
                                .ui({
                                    view: 'window',
                                    id: 'editMenu', // Unique identifier for the edit window
                                    fullscreen: screen.width < 500 ? true : false, // Fullscreen on small screens
                                    width: 500,
                                    head: {
                                        view: 'toolbar',
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Editar'), // Localized label for editing
                                                align: 'center',
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close', // Close icon
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide the edit window
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Center the window
                                    modal: true, // Make the window modal
                                    body: {
                                        view: 'form',
                                        id: 'editform', // Unique identifier for the edit form
                                        elements: [
                                            {
                                                cols: [
                                                    {
                                                        margin: 10,
                                                        rows: [
                                                            {
                                                                view: 'text',
                                                                labelPosition: 'top',
                                                                label: _('ID'), // Localized label
                                                                name: 'Id', // Field name
                                                                readonly: true, // Make ID field read-only
                                                                required: true, // Mark as required
                                                            },
                                                            {
                                                                view: 'text',
                                                                labelPosition: 'top',
                                                                label: _('Iso'), // Localized label
                                                                name: 'Iso', // Field name
                                                                required: true, // Mark as required
                                                            },
                                                            {
                                                                view: 'text',
                                                                labelPosition: 'top',
                                                                label: _(
                                                                    'Nombre', // Localized label
                                                                ),
                                                                name: 'NameCountry', // Field name
                                                                required: true, // Mark as required
                                                            },
                                                            {
                                                                view: 'combo',
                                                                labelPosition: 'top',
                                                                label: _(
                                                                    'Moneda', // Localized label
                                                                ),
                                                                name: 'Currency', // Field name
                                                                options: data.data, // Currency options
                                                                required: true, // Mark as required
                                                            },
                                                            {
                                                                view: 'combo',
                                                                labelPosition: 'top',
                                                                label: _(
                                                                    'Estado', // Localized label
                                                                ),
                                                                name: 'State', // Field name
                                                                options: [
                                                                    {
                                                                        id: 'A',
                                                                        value: _(
                                                                            'Activo', // Localized label
                                                                        ),
                                                                    },
                                                                    {
                                                                        id: 'I',
                                                                        value: _(
                                                                            'Inactivo', // Localized label
                                                                        ),
                                                                    },
                                                                ],
                                                                required: true, // Mark as required
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        margin: 10,
                                                        rows: [
                                                            {
                                                                view: 'combo',
                                                                labelPosition: 'top',
                                                                label: _(
                                                                    'Lenguage', // Localized label
                                                                ),
                                                                name: 'Language', // Field name
                                                                options: data.Data, // Language options
                                                                required: true, // Mark as required
                                                            },
                                                            {
                                                                view: 'text',
                                                                labelPosition: 'top',
                                                                label: _('UTC'), // Localized label
                                                                name: 'Utc', // Field name
                                                                required: true, // Mark as required
                                                            },
                                                            {
                                                                view: 'text',
                                                                labelPosition: 'top',
                                                                label: _(
                                                                    'Prefijo celular', // Localized label
                                                                ),
                                                                name: 'CellPrefix', // Field name
                                                                required: true, // Mark as required
                                                            },
                                                            {
                                                                view: 'text',
                                                                labelPosition: 'top',
                                                                label: _(
                                                                    'Código PATH', // Localized label
                                                                ),
                                                                name: 'CodePath', // Field name
                                                                required: true, // Mark as required
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button',
                                                        value: _('Cancelar'), // Localized label for cancel button
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Hide the edit window
                                                            $$('editform').setValues(
                                                                $$('editform').getCleanValues(), // Reset form values
                                                            );
                                                        },
                                                    },
                                                    {
                                                        view: 'button',
                                                        type: 'form',
                                                        value: _('Guardar'), // Localized label for save button
                                                        click: function ($e) {
                                                            var values = $$('editform').getValues(); // Get form values
                                                            if (
                                                                $$('editform').validate() // Validate form
                                                            ) {
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type for the request
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() + 'Setting/UpdateCountry', // API URL for updating country
                                                                        values, // Data to send
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(
                                                                                    'Error! ', // Show error message on failure
                                                                                );
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                text = JSON.parse(
                                                                                    text, // Parse response data
                                                                                );
                                                                                if (
                                                                                    text.HasError // Check for errors in response
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error: ' + text.AlertMessage, // Show error message
                                                                                    );
                                                                                } else {
                                                                                    webix.message(
                                                                                        'País editado satisfactoriamente', // Show success message
                                                                                    );
                                                                                    grid.load(
                                                                                        url +
                                                                                            '?start=0&count=' +
                                                                                            grid.data.$pagesize +
                                                                                            filter, // Reload grid data
                                                                                    );
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                                this.getTopParentView().hide(); // Hide the edit window
                                                            } else {
                                                                webix.message({
                                                                    title: _(
                                                                        '¡Error!', // Localized title for error message
                                                                    ),
                                                                    type: 'alert-error',
                                                                    text: _(
                                                                        'Completa los campos...', // Localized error message
                                                                    ),
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                })
                                .show(); // Show the edit window
                            $$('editform').parse(item); // Populate the form with item data
                        }
                    },
                });
        });
    }
}

// FILE DOCUMENTED
